import React, { useContext, useEffect, useState } from "react";
import logo from "../../../assets/LogoCadastro.png";

import PrimaryButton from "../../../components/PrimaryButton";
import TextField from "@mui/material/TextField";
import { ChevronLeft } from "react-feather";
import { useNavigate } from "react-router-dom";
import Telefone from "../../../components/Inputs/telephone";
import CustomAlert from "../../../components/Alerts/CustomAlert";

import {
  Container,
  Step1,
  Step2,
  HeaderCadastro,
  Button,
  Icon,
  Alert,
  BoxText,
  UnderlineText,
  TextDisabled,
} from "./style";
import OtpInput from "react-otp-input";
import { RegisterContext } from "../../../Utility/Context/RegisterContext";
import conexao from "../../../Services/index";
import { saveToken } from "../../../Services/auth";

export default function FirstAccessStep1() {
  const { firstAccessInfos } = useContext(RegisterContext);
  const [alertType, setAlertType] = useState("");
  const [showAlertOk, setShowAlertOk] = useState(false);
  const [showAlertError, setShowAlertError] = useState(false);
  const [token, setToken] = useState("");
  const [textAlert, setTextAlert] = useState("");

  const [auxTimer, setAuxTimer] = useState(false);
  const [totalTimeInSeconds, setTotalTimeInSeconds] = useState(2 * 60);
  const minutes = Math.floor(totalTimeInSeconds / 60);
  const seconds = totalTimeInSeconds % 60;

  const navigate = useNavigate();

  const closeAlerts = () => {
    setShowAlertOk(false);
    setShowAlertError(false);
  };

  async function ResendToken() {
    setAuxTimer(true);
    try {
      const { data } = await conexao.post(
        "api/user/first_access/token/create",
        {
          id: firstAccessInfos.user_id,
        }
      );
      if (data.error === `false`) {
        setTextAlert(data.message);
        setAlertType("success");
        setShowAlertError(true);
      } else {
        setTextAlert(data.message);
        setAlertType("error");
        setShowAlertError(true);
      }
    } catch (err) {}
  }

  async function handleNext() {
    try {
      const { data } = await conexao.post(
        "api/user/first_access/token/validation",
        {
          token: token,
        }
      );
      if (data.error === `false`) {
        saveToken(data.token);
        setTextAlert(data.message);
        setAlertType("success");
        setShowAlertError(true);
        setTimeout(() => {
          window.location.href = "/primeiro-acesso/2";
          // navigate("/primeiro-acesso/2");
        }, [1500]);
      } else {
        setTextAlert(data.message);
        setAlertType("error");
        setShowAlertError(true);
      }
    } catch (err) {
      setTextAlert("Por favor tente novamente!");
      setAlertType("error");
      setShowAlertError(true);
    }
  }

  useEffect(() => {
    if (totalTimeInSeconds === 0) {
      setAuxTimer(false);
      setTotalTimeInSeconds(2 * 60);
      return;
    } else if (auxTimer === true) {
      setTimeout(() => {
        setTotalTimeInSeconds(totalTimeInSeconds - 1);
      }, 1000);
    }
  }, [totalTimeInSeconds, auxTimer]);

  return (
    <>
      <Container>
        <HeaderCadastro>
          <Icon>
            <ChevronLeft
              color="#FFF"
              onClick={() => {
                navigate("/");
              }}
            />
          </Icon>
          <img
            src={logo}
            alt="logo"
            width={120}
            height={80}
          />
          <p>Primeiro acesso</p>
          <div>
            <Step1 />
            <Step2 />
          </div>
        </HeaderCadastro>
        <BoxText>
          <p>{firstAccessInfos?.message}</p>
        </BoxText>

        <div
          style={{
            display: `flex`,
            flexDirection: `column`,
            alignItems: `center`,
          }}
        >
          <OtpInput
            isInputNum={true}
            numInputs={4}
            separator={" "}
            value={token}
            onChange={(e) => {
              setToken(e);
            }}
            inputStyle={{
              width: "3rem",
              marginLeft: "0.25rem",
              marginRight: "0.25rem",
              height: "3rem",
              fontSize: "2rem",
              borderRadius: 4,
              border: "1px solid #ccc",
            }}
          />
          {auxTimer === false ? (
            <UnderlineText onClick={ResendToken}>Reenviar Código</UnderlineText>
          ) : (
            <TextDisabled>
              Reenviar Código -{" "}
              <b>
                {" "}
                {minutes}:{seconds.toString().padStart(2, "0")}{" "}
              </b>
            </TextDisabled>
          )}
        </div>

        <Button>
          <PrimaryButton
            text="Próximo"
            funcao={handleNext}
            disabled={token.length !== 4 ? true : false}
          />
        </Button>
        <Alert>
          <CustomAlert
            type={alertType}
            alertText={textAlert}
            show={showAlertOk || showAlertError}
            close={() => closeAlerts()}
          />
        </Alert>
      </Container>
    </>
  );
}
